import { Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Brand } from "@/components/Brand";
import { LogOut, UserCircle } from "lucide-react";
import { PanicButton } from "@/components/PanicButton";
import { PanicBanner } from "@/components/PanicBanner";
import { PatrolAlertBanner } from "@/components/PatrolAlertBanner";
import { OperationalInbox } from "@/components/OperationalInbox";
import { isOperationalRole, roleLabel } from "@/lib/roles";

/** Mobile-first layout for supervisor & vigilador */
export default function MobileLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const onLogout = async () => { await logout(); nav("/login"); };

  return (
    <div style={{ minHeight: "100vh", background: "var(--invict-bone)", paddingBottom: "calc(120px + env(safe-area-inset-bottom, 0px))" }}>
      <header style={{
        background: "#0A0A0A", color: "#FFFBF4", padding: "16px 18px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        position: "sticky", top: 0, zIndex: 40,
      }}>
        <Brand size="sm" iconOnly />
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Link to="/vigilador/perfil" style={{
            background: "transparent", border: "1px solid rgba(255,251,244,0.2)",
            color: "rgba(255,251,244,0.7)", padding: "6px 10px", borderRadius: 2,
            display: "inline-flex", alignItems: "center",
          }} data-testid="nav-perfil" aria-label="Perfil">
            <UserCircle size={14} />
          </Link>
          <button onClick={onLogout} style={{
            background: "transparent", border: "1px solid rgba(255,251,244,0.2)",
            color: "rgba(255,251,244,0.7)", padding: "6px 12px", borderRadius: 2,
            fontSize: 11, letterSpacing: "0.05em", textTransform: "uppercase", fontWeight: 700,
            display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer",
          }} data-testid="logout-button">
            <LogOut size={12} /> Salir
          </button>
        </div>
      </header>
      {isOperationalRole(user?.role) && <PanicBanner />}
      {isOperationalRole(user?.role) && <PatrolAlertBanner />}
      {isOperationalRole(user?.role) && <OperationalInbox />}
      <div style={{ padding: "8px 4px 4px" }}>
        <div style={{ padding: "12px 16px", color: "var(--invict-text-muted)", fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase", fontWeight: 700 }}>
          Hola, <span style={{ color: "var(--invict-black)" }}>{user?.name}</span> · {roleLabel(user?.role)}
        </div>
        <Outlet />
      </div>
      <PanicButton />
    </div>
  );
}
